export const getDateDifferenceInDays = (startDate: string, endDate: string, fixed: number = 2) => {
  if (!startDate || !endDate) return null;

  const start = new Date(startDate);
  const end = new Date(endDate);

  return ((end.getTime() - start.getTime()) / 86400000).toFixed(fixed);
};
